import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LinkTemplateComposer = lazy(() =>
  import("@scenes/MessageComposition/Email/LinkTemplates/LinkTemplateComposer").then((module) => ({
    default: module.LinkTemplateComposer,
  }))
);

export const engagementTemplatesAndMediaLinkTemplatesNewNRO: NavigationRoutingObject = {
  Component: LinkTemplateComposer,
  componentFeatureFlippers: ["link_templates_nro_component"],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-link-templates-new-nro-heading", "New Link Template"),
  pageNameForTracking: () => "New Link Template",
  icon: "nav-system-email-link-templates",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("link_templating")) {
      return false;
    }
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "editLinkTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
